import { render, staticRenderFns } from "./bniesCategory.vue?vue&type=template&id=2984a69d&"
import script from "./bniesCategory.vue?vue&type=script&lang=js&"
export * from "./bniesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports